<template lang="pug">
div
  section.u-mt-md(v-for="service,idx in $t('services')")
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi.h2(:title="service.mantra" tag="h1" v-if="idx == 1")
        AppTitle.u-mb-mi(:title="service.mantra" tag="h2" v-else)
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="(item,key) in service.items")
            h4 #[AppLink(:to="`/industries/${key}`"  :title="item.title" )  {{item.title}} ]
            p {{item.desc}}


  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('exploreMantra')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/services" :title="$t('exploreServices')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreServices')}}
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/solutions" :title="$t('exploreSolutions')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreSolutions')}}

  section.u-mt-sm.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")
</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat industries",
    "pageDesc":"We provide design, development, business and technology solutions in a variety to support different industries.",
    "mantra":"Innovation tailored |for human needs.",
    "services":{
      "1":{
        "mantra":"Industry specific solutions.",
        "items":{
          "ecommerce":{
            "title":"Retail and ecommerce",
            "desc":"Helping you start your online business through an ecommerce platform that lets you expand overseas and reach more people."
          },
          "news":{
            "title":"News",
            "desc":"We design and develop custom online magazines and newspapers to help you reach your readers faster and share instant breaking news."
          },
          "food":{
            "title":"Food and beverage",
            "desc":"Focus on delivery delicious food and let us handle the technical matters. From software to mobile apps and websites, we provide you with cutting edge solutions."
          },
          "manufacturing":{
            "title":"Manufacturing",
            "desc":"Working in wood, steel or medication, we let you help handle your production lines and reach a more effective level of production. "
          },
          "healthcare":{
            "title":"Healthcare",
            "desc":"Creating healthcare solutions for clinics, hospitals and doctors. Whether softwares, mobile apps or websites, we help you connect with your patients directly."
          },
          "finance":{
            "title":"Finance",
            "desc":"Working with cryptocurrency websites and innovative business models that support the finance industry to create technological solutions that accelerate their growth."
          },
          "education":{
            "title":"Education",
            "desc":"Working with partners to enhancing the quality of educational means by integrating technology for an interactive learning experience."
          },
          "government":{
            "title":"Government",
            "desc":"Collaborating with government institutions to develop and design custom made solutions that transform them into the digital edge."
          },
          "charity":{
            "title":"Charity",
            "desc":"Whether a social enterprise or charitable organization, we digitize your operations to help drive your mission and spread the word about your causes."
          },
          "real-estate":{
            "title":"Real estate",
            "desc":"We design and develop custom websites, mobile apps and software solutions that helps you penetrate the market of real estate."
          },
          "furniture":{
            "title":"Furniture",
            "desc":"Export your masterpieces to anywhere around the world and organize your in house operations through smart solutions."
          }
        }
      }
    },
    "exploreMantra":"Explore by further |categories.",
    "explorePlatforms":"Platforms",
    "exploreServices":"Services",
    "exploreSolutions":"Solutions",
    "cta":"Let's have <br> Coffee togther."

  },
  "ar": {
    "pageTitle":"صناعات بيانات",
    "pageDesc":"نقدم حلول فى البرمجة و التصميم و التكنولوجيا والأعمال لتخدم كافة الصناعات منها الأثاث والصحة والتعليم والأغذية وغيرها.",
    "mantra":"نبتكر من أجل |نجاح أعمالك.",
    "services":{
      "1":{
        "mantra":"حلول مخصصة للصناعات المختلفة.",
        "items":{
          "ecommerce":{
            "title":"التجارة الالكترونية",
            "desc":"نساعدك على إنشاء عملك التجاري على الإنترنت من خلال منصة للتجارة الإلكترونية التي تسمح لك بالتوسع في كل مكان والوصول إلى المزيد من العملاء."
          },
          "news":{
            "title":"الأخبار",
            "desc":"نقوم بتصميم وتطوير المجلات والصحف الإلكترونية لمساعدتك على الوصول إلى القراء بشكل أسرع وكذلك لمشاركة الأخبار العاجلة والفورية معهم."
          },
          "food":{
            "title":"الأغذية",
            "desc":"ركز على تقديم وتوصيل الأغذية والمشروبات اللذيذة ودعنا نتعامل مع الأمور الفنية، من البرامج إلى تطبيقات الجوال ومواقع الويب نوفر لك حلولًا متطورة."
          },
          "manufacturing":{
            "title":"التصنيع",
            "desc":"سواء تعمل في الأخشاب أو الصلب أو الأدوية، نعمل على مساعدتك في معالجة خطوط إنتاجك والوصول إلى مستوى إنتاج أكثر فاعلية."
          },
          "healthcare":{
            "title":"الرعاية الصحية",
            "desc":"نعمل على إيجاد حلول تقنية  للرعاية الصحية للعيادات والمستشفيات والأطباء، سواء كانت هذه الحلول  برامج أو تطبيقات للجوال أو مواقع، فإننا نساعدك على التواصل مع مرضاك مباشرةً."
          },
          "finance":{
            "title":"المالية",
            "desc":"نعمل على مواقع الويب المشفرة ونماذج الأعمال المبتكرة التي تدعم صناعة التمويل من أجل إنشاء حلول تكنولوجية تسرع من النمو."
          },
          "education":{
            "title":"التعليم",
            "desc":"نعمل مع شركائنا في النجاح من أجل تحسين مستوى جودة الوسائل التعليمية من خلال دمج التكنولوجيا بالتجربة التعليمة وجعلها تجربة تعليمية تفاعلية."
          },
          "government":{
            "title":"الحكومة",
            "desc":"نتعاون مع المؤسسات الحكومية من أجل برمجة وتصميم حلول مخصصة لنقلها إلى العالم الرقمي."
          },
          "charity":{
            "title":"الأعمال الخيرية",
            "desc":"سواء كنت مؤسسة اجتماعية أو مؤسسة خيرية، نساعدك على جعل التواصل مع المتطوعين بشكل أبسط ونشر رسالتك وأهدافك بوضوح."
          },
          "real-estate":{
            "title":"العقارات",
            "desc":"نقوم بتصميم وبرمجة مواقع وتطبيقات الجوال والحلول البرمجية التي تساعدك على اختراق سوق العقارات بنجاح."
          },
          "furniture":{
            "title":"الأثاث",
            "desc":"قم بتصدير منتجاتك إلى أي مكان في العالم ونظم عملياتك الداخلية من خلال العديد من الحلول الذكية التي تساعدك على التواصل مع عملائك."
          }
        }
      }
    },
    "exploreMantra":"استكشف المزيد بما |يناسب احتياجات أعمالك.",
    "explorePlatforms":"المنصات",
    "exploreServices":"الخدمات",
    "exploreSolutions":"الحلول",
    "cta":"دعنا نتناول القهوة <br> سويًا."
  }
}
</i18n>
